import type { SupportCategory, SupportSubcategory, SupportSubcategoryQuestion } from './types';

export const MAINTENANCE_CATEGORIES: SupportCategory[] = [
  { id: 'maintenance-location', label: 'Location', departmentId: 'Maintenance' },
];

export const MAINTENANCE_SUBCATEGORIES: SupportSubcategory[] = [
  { id: 'maintenance-location-sub', label: 'Location', categoryId: 'maintenance-location' },
];

export const MAINTENANCE_QUESTIONS: SupportSubcategoryQuestion[] = [
  {
    id: 'maintenance-location-1',
    subcategoryId: 'maintenance-location-sub',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'maintenance-location-2',
    subcategoryId: 'maintenance-location-sub',
    type: 'text',
    label: 'Location',
    required: true,
  },
  {
    id: 'maintenance-location-3',
    subcategoryId: 'maintenance-location-sub',
    type: 'text',
    label: 'Room',
    required: true,
  },
];
